
import QInput from 'quasar/src/components/input/QInput.js';;
import { defineComponent } from "vue";

//stores
import { useBillStore } from "@/stores/BillStore";

import { mapWritableState, mapActions, mapState } from "pinia";

export default defineComponent({
  name: "CheckStep",

  components: {},

  data: () => ({
    show: true,
  }),

  computed: {
    ...mapWritableState(useBillStore, ["billData"]),
    ...mapState(useBillStore, ["findLoading", "paymentTypes"]),
  },

  methods: {
    ...mapActions(useBillStore, ["checkBill"]),

    test() {
      (this.$refs["numBill"] as typeof QInput).validate();
      (this.$refs["pinBill"] as typeof QInput).validate();
      if (
        !(this.$refs["numBill"] as typeof QInput).hasError &&
        !(this.$refs["pinBill"] as typeof QInput).hasError
      ) {
        this.checkBill();
      }
    },
  },
});
